import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, NgZone } from '@angular/core';
import { AttachmentsService } from '../../services/attachments-service/attachments-service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FileuploadService } from 'src/app/services/FileUpload/fileupload.service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
declare var $: any;


@Component({
  selector: 'app-attachments-view',
  templateUrl: './attachments-view.component.html',
  styleUrls: ['./attachments-view.component.scss']
})
export class AttachmentsViewComponent {
  @Input() context;
  attachments: any = [];
  attachmentsList: any = [];
  fileToUpload: File;
  imgUrl: any = [];
  customSortCols: any = [];
  containerHeight: any;
  loading:boolean;
  tcontainer = {};
  constructor(private formbuilder: FormBuilder, private fileUploadService: FileuploadService, private attachmentsService: AttachmentsService,private standardUiService: StandardUIService
  ) {

  }
  ngOnInit() {
    this.loading= true;
    $("#data-table-attachments" + this.randomID + "_wrapper").remove();
    
    let navbarH = $('.layout-navbar').height();
    let docH = $(window).height();
    this.containerHeight = (docH - navbarH - 290) + 'px';

    this.tcontainer = {
      'height': this.containerHeight
    };

    let payload = {
      "entityName": "Attachment",
      "payLoad": {
        "incidentid": this.context.id

      }
    }
    if(!isNaN(this.context.id)){
      this.attachmentsService.getAttachments(payload).subscribe((res: any) => {
        this.attachments = res.payLoads;
        console.log(this.attachments);
        this.loading=false
        this.dataTable();
      })
    } 
  }
  dataTable() {

    setTimeout(() => {
      const screenWidth = window.innerWidth;
      const isSmallScreen = screenWidth <= 1200;
      $.fn.dataTable.ext.errMode = 'none';
      ($('.pane:visible #data-table-attachments' + this.randomID) as any).dataTable({


        "language": {
          "paginate": {
            "previous": "",
            "next": ""
          },
          "lengthMenu": "Records per page _MENU_ ",
        },
        
        searching: false,
        pageLength: 10,
        order: [[2,'desc']],
        "columnDefs": [
          { "orderable": false, "targets": 3 }
        ],
        
        // responsive: isSmallScreen ? true : false,
        // columnDefs: [{ width: '20%', targets: 0 }],
        lengthMenu: [
          [10, 25, 50, -1],
          [10, 25, 50, 'All']
        ],
        fixedColumns: {
          start: isSmallScreen ? 0 : 1,
          end: 1
        },

        paging: true,
        fixedHeader: true,
        scrollCollapse: true,
        scrollX: true,

        scrollY: this.containerHeight,

        dom: 'frtlip',
        buttons: [
          {
            extend: 'excel',
            text: '<i class="fa-solid fa-download"></i>',
            title: 'Attachments'
          }
        ],
        drawCallback: function (settings) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      });

    }, 200)
  }
  isImageUrl(url: string): boolean {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
  }
  randomId() {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + Date.now();
  }
  randomID = this.randomId();
  handleFileInput(files: FileList) {

    for (let i = 0; i < files.length; i++) {
      this.fileToUpload = files[i];
      this.fileUploadService.upload(this.fileToUpload).subscribe(response => {
        console.log(response);
        let payload = {
          entityName: "Attachment",
          "payLoad": {
            "Attachment.attachfiles": response,
            "Attachment.incidentid": this.context.id,
          }
        }
        console.log(payload);
        this.attachmentsService.entityCreate(payload).subscribe(result => {
          console.log(result);
         this.ngOnInit()
        })


      });
    }
  }
  getfileName(imgUrl: string): string {
    // console.log(imgUrl)
    // let arr: any = imgUrl.split('sections/')[1].split('_');

    // return arr[1].split('/')[1]+arr[2]+arr[3]+arr[5].split('.')[1];

    const filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1);

    const lastUnderscorePos = filename.lastIndexOf('_');
    const secondLastUnderscorePos = filename.lastIndexOf('_', lastUnderscorePos - 2);

    const baseName = filename.substring(0, secondLastUnderscorePos);

    const extension = filename.split('.').pop();

    return `${baseName}.${extension}`;
  }
}
